(function() {
    'use strict';
    angular
        .module('portalApp')
        .factory('ApplicationFeatureEntityMap', ApplicationFeatureEntityMap);

    ApplicationFeatureEntityMap.$inject = ['$resource'];

    function ApplicationFeatureEntityMap ($resource) {
        var resourceUrl =  'api/application-feature-entity-maps/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
